import React from 'react'
import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className='pageNotFound d-flex flex-column justify-content-center align-items-center'>
      <img src="/images/icons/404-error.png" alt="404-error" />
      <h1 className='oops-heading'>Oops!</h1>
      <p className='oops-text'>404 - Page Not Found</p>
      <Link to="/" className="custom-btn btn d-flex justify-content-center align-items-center rounded-pill back-to-home">
        Go To Home
      </Link>
    </div>
  )
}
